import React from 'react';
import Chip from '@mui/material/Chip';

/**
 * Component for rendering priority badge with appropriate color
 */
export const PriorityBadge = ({ priority }) => {
  if (!priority) return null;

  const getColor = () => {
    const lowerPriority = priority.toLowerCase();
    if (lowerPriority === 'high' || lowerPriority === 'critical') return 'error';
    if (lowerPriority === 'medium') return 'warning';
    return 'success';
  };

  return (
    <Chip
      label={priority}
      color={getColor()}
      size="small"
      sx={{ mr: 1 }}
    />
  );
};

/**
 * Component for rendering timeframe badge
 */
export const TimeframeBadge = ({ timeframe }) => {
  if (!timeframe) return null;

  return (
    <Chip
      label={timeframe}
      variant="outlined"
      size="small"
    />
  );
};
